export const listenToTdMouseover = () => {
  const tdElements = document.getElementsByClassName("scrollable")

  Array.from(tdElements).forEach((td) => {
    const scrollContainer = td.querySelector(".scroll-container")

    td.addEventListener("mouseover", () => {
      //   alert(scrollContainer.innerHTML)
      if (scrollContainer.scrollWidth > scrollContainer.clientWidth) {
        const scrollDistance =
          scrollContainer.scrollWidth - scrollContainer.clientWidth

        scrollContainer.scrollTo({
          left: scrollDistance,
          behavior: "smooth",
        })
      }
    })

    // Reset the scroll position on mouseout (optional)
    td.addEventListener("mouseout", () => {
      scrollContainer.scrollTo({
        left: 0,
        behavior: "smooth",
      })
    })
  })
}
